import type { PortalSubscriptionUsage } from '../types/users.types';
import { UsageCell } from './usage-cell';

interface UsageBreakdownCellProps {
  usage: PortalSubscriptionUsage;
}

export function UsageBreakdownCell({ usage }: UsageBreakdownCellProps) {
  return (
    <div className="flex min-w-[180px] flex-col gap-3">
      <UsageCell
        usage={usage.gen_edit_used}
        limit={usage.gen_edit_limit}
        label="gens + edits (30d)"
      />
      <UsageCell
        usage={usage.resize_used}
        limit={usage.resize_limit}
        label="resizes (30d)"
      />
    </div>
  );
}
